import { atom } from "recoil";

export const billingAtom = atom({
  key: "billingAtom",
  default: null,
});
